
import { computed, getCurrentInstance, PropType, ref } from 'vue'
import {
  Offer, isBundleOffer, isHomeOffer, createTranslatedOfferBenefitsInstance, TranslatableContext,
} from '@alao-frontend/core'
import AlButton from '~/components/ui/AlButton/AlButton.vue'
import OfferCardPrice from '~/components/offers/NewOfferCard/OfferCardPrice.vue'
import OfferCardMain from '~/components/offers/NewOfferCard/OfferCardMain.vue'
import OfferBenefitBadge from '~/components/offers/benefits/OfferBenefitBadge.vue'
import OfferOptions from '~/components/offers/OfferOptions'
import ExpertTip from '~/components/offers/OfferCard/ExpertTip'
import { checkDateLessDays } from '~/utils/check-date-less-days'
export default {
  name: 'NewOfferCard',
  components: {
    OfferOptions,
    OfferBenefitBadge,
    OfferCardPrice,
    OfferCardMain,
    ExpertTip,
    AlButton,
  },
  props: {
    offer: { type: Object as PropType<Offer>, required: true },
    title: { type: String, default: '' },
    slug: { type: String, default: '' },
    url: { type: String, required: true },
    clickable: { type: Boolean, default: true },
    pricesTooltipTrigger: { type: String, default: 'hover' },
  },
  emits: ['click'],
  setup (props: any) {
    const instance = getCurrentInstance()

    const $t = computed(() => {
      return (key: string, props: any) =>
        instance?.proxy?.$i18n?.t(key, props) || ''
    })
    const bundleBenefits = ref(isBundleOffer(props.offer)
      ? createTranslatedOfferBenefitsInstance(
        props.offer,
        { t: $t } as unknown as TranslatableContext)
      : '')
    const endDateInFewDays = computed(() => {
      if (!props.offer.endDate) {
        return props.offer.endDate
      }
      return checkDateLessDays(props.offer.endDate) ? props.offer.endDate : null
    })

    return {
      bundleBenefits,
      endDateInFewDays,
    }
  },
  methods: { isHomeOffer, isBundleOffer },
}
